import { IconLogout } from '@tabler/icons-react';
import type { ReactNode } from 'react';

export function LogoutControl({
  onLogout,
  impersonating,
  onStopImpersonating,
}: {
  onLogout?: () => void;
  impersonating?: { name: string } | null;
  onStopImpersonating?: () => void;
}) {
  return (
    <span className="flex min-w-0 items-center gap-1">
      {impersonating && onStopImpersonating ? (
        <HeaderButton
          onClick={onStopImpersonating}
          label={`Log out of ${impersonating.name}`}
          track="stop-impersonating"
          icon={
            <span aria-hidden className="text-lg leading-none">
              👀
            </span>
          }
        />
      ) : null}
      {onLogout ? (
        <HeaderButton
          onClick={onLogout}
          label="Log out"
          icon={<IconLogout size={20} aria-hidden />}
        />
      ) : null}
    </span>
  );
}

function HeaderButton({
  onClick,
  label,
  icon,
  track,
}: {
  onClick: () => void;
  label: string;
  icon: ReactNode;
  track?: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      data-track={track}
      className="focus-visible:outline-brand portal-press flex min-w-0 cursor-pointer items-center gap-2 rounded-lg px-2 py-1.5 hover:bg-white/10 focus-visible:outline-2 focus-visible:outline-offset-2"
    >
      <span className="shrink-0">{icon}</span>
      <span className="truncate text-sm font-medium max-sm:hidden">
        {label}
      </span>
    </button>
  );
}
